<script>
import { mapState, mapActions } from 'pinia';
import useNotificationToastsStore from '../../components/countly/lib-components/notification/store';
import useDialogsStore from '../../components/countly/lib-components/dialog/store';
import useModalClientsStore from '../../components/countly/lib-components/modal/store';

export default {
  computed: {
    ...mapState(useDialogsStore, ['confirmDialogs', 'messageDialogs']),
    ...mapState(useNotificationToastsStore, ['notificationToasts']),
    ...mapState(useModalClientsStore, ['nClients']),
  },
  methods: {
    ...mapActions(useDialogsStore, ['removeDialog']),
    ...mapActions(useNotificationToastsStore, ['removeNotificationToast']),
    onCloseDialog(dialog, status) {
      if (dialog.callback) {
        dialog.callback(status);
      }
      this.removeDialog(dialog.id);
    },
    onCloseNotification(id) {
      this.removeNotificationToast(id);
    },
  },
};
</script>

<template>
  <div>
    <div>
      <div
        id="vue-common-overlay"
        :class="{ 'is-active': nClients > 0 }"
      />
    </div>
    <div class="notification-toasts">
      <cly-notification
        v-for="toast in notificationToasts"
        :id="toast.id"
        :key="toast.id"
        :text="toast.text"
        :auto-hide="toast.autoHide"
        :color="toast.color"
        :closable="true"
        class="notification-toasts__item"
        @close="onCloseNotification"
      />
    </div>
    <cly-confirm-dialog
      v-for="dialog in confirmDialogs"
      :key="dialog.id"
      visible
      :dialog-type="dialog.type"
      :save-button-label="dialog.confirmLabel"
      :cancel-button-label="dialog.cancelLabel"
      :title="dialog.title"
      @confirm="onCloseDialog(dialog, true)"
      @cancel="onCloseDialog(dialog, false)"
      @close="onCloseDialog(dialog, false)"
    >
      <div>
        {{ dialog.message }}
      </div>
    </cly-confirm-dialog>
    <cly-message-dialog
      v-for="dialog in messageDialogs"
      :key="dialog.id"
      visible
      :show-close="false"
      :dialog-type="dialog.type"
      :confirm-button-label="dialog.confirmLabel"
      :title="dialog.title"
      @confirm="onCloseDialog(dialog, true)"
      @close="onCloseDialog(dialog, false)"
    >
      <div>
        {{ dialog.message }}
      </div>
    </cly-message-dialog>
  </div>
</template>
